import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EuiIconComponent } from './eui-icon.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiIconComponent],
    declarations: [EuiIconComponent],
})
export class EuiIconModule {
}
